import { useRulesEngine } from '../../../../../hooks/useRulesEngine';
import { useCategoryRulesEngine } from '../../../../../hooks/useCategoryRulesEngine';
import { RuleBuilderProps } from './types';

export const useRuleBuilder = (props: RuleBuilderProps) => {
  const { categoryId } = props;

  // Conditionally use the correct engine based on whether categoryId is provided
  const regularEngine = useRulesEngine(props.sectionId);
  const categoryEngine = useCategoryRulesEngine(props.sectionId, categoryId!);
  const { rules, createRule, removeRule } = categoryId
    ? categoryEngine
    : regularEngine;

  const handleAddRule = () => {
    // Generate a unique name for the rule
    const ruleNumber = rules.length + 1;
    const ruleName = `Rule ${ruleNumber}`;

    createRule(ruleName);
  };

  const handleRemoveRule = (ruleId: string) => {
    // Prevent deletion if only one rule exists
    if (rules.length <= 1) {
      console.warn(
        '⚠️ Cannot delete the last rule. At least one rule must exist.'
      );
      return;
    }
    removeRule(ruleId);
  };

  return {
    rules,
    handleAddRule,
    handleRemoveRule,
  };
};
